module.exports = __webpack_public_path__ + "img/expert-1.c7555620.png";